/**
 * Maps BACEN COMPE (3-digit bank code) to `@edusites/bancos-brasil` svgBanco `nome` slugs.
 * Only institutions covered by the icon library are listed; others return null (use letter fallback).
 */
const compeCodeToSvgSlugMap: Record<string, string> = {
  '001': 'bancodobrasil',
  '033': 'santander',
  '077': 'inter',
  '104': 'caixa',
  '197': 'stone',
  '208': 'btg',
  '212': 'original',
  '218': 'bs2',
  '237': 'bradesco',
  '260': 'nubank',
  '290': 'pagbank',
  '323': 'mercadopago',
  '336': 'c6',
  '341': 'itau',
  '380': 'picpay',
  '422': 'safra',
  '623': 'pan',
  '748': 'sicredi',
  '756': 'sicoob',
};

function normalizeCompeDigits(value: string): string | null {
  const digits = value.replace(/\D/g, '');
  if (!digits) {
    return null;
  }
  if (digits.length <= 3) {
    return digits.padStart(3, '0');
  }
  return digits.slice(-3).padStart(3, '0');
}

/** Resolve svgBanco slug from COMPE; null when unknown or unmapped. */
export function compeToSvgBancoSlug(
  compeCode: string | number | null | undefined,
): string | null {
  if (compeCode === undefined || compeCode === null) {
    return null;
  }
  const trimmed = String(compeCode).trim();
  if (!trimmed) {
    return null;
  }
  const key = normalizeCompeDigits(trimmed);
  if (!key) {
    return null;
  }
  return compeCodeToSvgSlugMap[key] ?? null;
}
